/**
 * ak-geo-rank.js  |  STEP 8: ranker + card renderer + grid swap + infinite scroll
 *
 *
 * Console:
 *   AKGeo.report()            rank every grid and log the tables
 *   AKGeo.at(lat, lng)        re-rank from a pretend location
 *   AKGeo.apply()             swap to ranked order and arm the scroller
 *   AKGeo.applyAt(lat, lng)   same, from a pretend location
 *   AKGeo.more()              append the next batch without scrolling
 *   AKGeo.all()               append everything left, for testing
 *   AKGeo.restore()           put the original Liquid order back
 *   AKGeo.preview(handle)     one client card beside its Liquid twin
 *   AKGeo.clearPreview()      remove preview cards
 */

(function () {
  if (window.AKGeo) return;

  var AUTO_APPLY = true;             // flip to true to go live;  If set to false, then add ?akgeo=1 as a debug aid

  var BATCH_FALLBACK = 24; 
  var SCROLL_MARGIN_PX = 800;         // start the next batch this far out
  var ROAD_FACTOR = 1.3;
  var DISTANCE_CUTOFF_KM = 30;
  var BAND_KM = 10;
  var ORIGIN_ALIAS = { 'delhi ncr': 'delhi' };
  var SRCSET_WIDTHS = [165, 360, 533, 720, 940, 1066];

  function norm(s) { return String(s == null ? '' : s).trim().toLowerCase(); }
  function toRad(d) { return (d * Math.PI) / 180; }
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function batchSize(cfg) {
    var n = Number(cfg.batch) || 0;
    if (n > 0) return n;
    return Math.min((cfg._reg && cfg._reg.limit) || BATCH_FALLBACK, BATCH_FALLBACK);
  }

  /* Page 2 and beyond are plain Liquid pages reached from the hidden page
     links. They keep their own venues and a visible pager, so the script
     leaves them alone. */
  function pageNum() {
    var m = window.location.search.match(/[?&]page=(\d+)/);
    return m ? (parseInt(m[1], 10) || 1) : 1;
  }

  function hidePager(cfg, hide) {
    var p = cfg && cfg.sectionId ? document.getElementById('AkPager-' + cfg.sectionId) : null;
    if (p) p.hidden = !!hide;
  }

  function airKm(lat1, lon1, lat2, lon2) {
    var R = 6371;
    var dLat = toRad(lat2 - lat1);
    var dLon = toRad(lon2 - lon1);
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);
    return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  }

  // --- origin ---------------------------------------------------------------

  function locationMap() {
    var el = document.getElementById('ak-location-redirects');
    if (!el) return [];
    try { return JSON.parse(el.textContent) || []; } catch (e) { return []; }
  }

    /* AKLocation owns the ladder: an explicit place beats a device fix. Read it
     directly rather than the flat mirror, because GPS_Sort_Gclid also writes
     the flat keys on a silent read and would otherwise clobber a pin. */
  function visitorPoint() {
    if (window.AKLocation && AKLocation.position) {
      var p = AKLocation.position();
      if (p) {
        var plat = parseFloat(p.lat), plng = parseFloat(p.lng);
        if (isFinite(plat) && isFinite(plng) && (plat !== 0 || plng !== 0)) {
          return { lat: plat, lng: plng, source: p.from === 'pin' ? 'place' : 'visitor' };
        }
      }
    }
    if (typeof AKStore === 'undefined' || !AKStore.get) return null;
    var lat = parseFloat(AKStore.get('latitude'));
    var lng = parseFloat(AKStore.get('longitude'));
    if (!isFinite(lat) || !isFinite(lng) || (lat === 0 && lng === 0)) return null;
    return { lat: lat, lng: lng, source: 'visitor' };
  }

  function isRealPoint(o) { return !!o && (o.source === 'visitor' || o.source === 'place'); }

  function centroidFor(city) {
    var key = ORIGIN_ALIAS[norm(city)] || norm(city);
    var rows = locationMap();
    for (var i = 0; i < rows.length; i++) {
      if (norm(rows[i].city_name) === key) {
        var lat = parseFloat(rows[i].lat), lng = parseFloat(rows[i].lng);
        if (isFinite(lat) && isFinite(lng) && (lat !== 0 || lng !== 0)) {
          return { lat: lat, lng: lng, source: 'centroid:' + rows[i].city_name };
        }
      }
    }
    return null;
  }

  /**
   * The centre the publisher built this page's pool around, carried in the
   * pointer entry. Falls back to the registry lookup when the pointer entry
   * predates step 2, and the registry is also the fallback for a city whose
   * row is draft, where akz.cities holds nothing.
   */
  function pageCentre_(cfg) {
    var lat = parseFloat(cfg.lat), lng = parseFloat(cfg.lng);
    if (isFinite(lat) && isFinite(lng) && (lat !== 0 || lng !== 0)) {
      return { lat: lat, lng: lng, source: 'centroid:' + cfg.city };
    }
    return centroidFor(cfg.city);
  }
 
  /**
   * Rank from the visitor when they are within the pool threshold of the page
   * centre, and from the page centre otherwise. Ordering 400 km of Amritsar
   * venues by which one sits a few km nearer Delhi is noise, and the centroid
   * source also stops distance labels painting, which is the right outcome
   * there. The override path goes through the same test so AKGeo.applyAt is a
   * faithful simulator.
   */
  function originFor(cfg, override) {
    var here = override
      ? { lat: override.lat, lng: override.lng, source: 'override' }
      : visitorPoint();
  
    var centre = pageCentre_(cfg);
    if (!here) return centre;
  
    var km = Number(cfg.km) || 0;
    if (centre && km > 0 && airKm(here.lat, here.lng, centre.lat, centre.lng) > km) {
      return { lat: centre.lat, lng: centre.lng, source: 'centroid:far:' + cfg.city };
    }
    return here;
  }

  // --- feed -----------------------------------------------------------------

  var feedCache = {};
  function loadFeed(url) {
    if (!feedCache[url]) {
      feedCache[url] = fetch(url, { credentials: 'omit' }).then(function (r) {
        if (!r.ok) throw new Error('feed http ' + r.status);
        return r.json();
      });
    }
    return feedCache[url];
  }

  // --- pool and rank --------------------------------------------------------

  function inPool(row, cfg, pageCity) {
    if (cfg.cats && cfg.cats.length) {
      var want = cfg.cats.map(norm), have = (row.cat || []).map(norm), hit = false;
      for (var i = 0; i < have.length; i++) {
        if (want.indexOf(have[i]) > -1) { hit = true; break; }
      }
      if (!hit) return false;
    }
    return true;
  }

  function tierOf(row, pageCity) {
    if (norm(row.c) === pageCity && typeof row.tr === 'number') return row.tr;
    return 5;
  }

  function rank(rows, cfg, origin) {
    var pageCity = norm(cfg.city), scored = [];
    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];
      if (!inPool(row, cfg, pageCity)) continue;
      var dist = airKm(origin.lat, origin.lng, row.la, row.ln) * ROAD_FACTOR;
      scored.push({
        h: row.h, t: row.t, city: row.c,
        tier: tierOf(row, pageCity),
        same: norm(row.c) === pageCity ? 0 : 1,
        sup: row.s ? 1 : 0,
        dist: dist, band: Math.max(1, Math.ceil(dist / BAND_KM)), row: row
      });
    }
    scored.sort(cmpRank);
    return scored;
  }

  function cmpRank(a, b) {
    if (a.tier !== b.tier) return a.tier - b.tier;
    if (a.tier < 5) return a.dist - b.dist;
    if (a.same !== b.same) return a.same - b.same;
    if (a.band !== b.band) return a.band - b.band;
    if (a.sup !== b.sup) return a.sup - b.sup;
    return a.dist - b.dist;
  }

  /* A venue that went live after the last nightly feed publish is in the
     Liquid render but not in the feed, so it showed on first paint and then
     vanished when the ranked list replaced the grid. Keep any such card,
     ranked from its own card coordinates like any other untiered venue, until
     the next publish carries it. It has no categories until then, so a
     category chip hides it. */
  function withOrphans(cfg, reg, feed, ordered, origin) {
    var known = {};
    (feed.items || []).forEach(function (r) { if (r && r.h) known[r.h] = true; });
    ordered.forEach(function (x) { known[x.h] = true; });
    var pageCity = norm(cfg.city), extra = [];
    reg.original.forEach(function (li) {
      var h = handleOf(li);
      if (!h || known[h]) return;
      var wrap = li.querySelector('.card-wrapper');
      var la = wrap ? parseFloat(wrap.getAttribute('data-lat')) : NaN;
      var ln = wrap ? parseFloat(wrap.getAttribute('data-long')) : NaN;
      if (!isFinite(la) || !isFinite(ln)) return;
      var city = wrap.getAttribute('data-ak-city') || '';
      var dist = airKm(origin.lat, origin.lng, la, ln) * ROAD_FACTOR;
      known[h] = true;
      extra.push({
        h: h, t: '', city: city, tier: 5,
        same: norm(city) === pageCity ? 0 : 1, sup: 0,
        dist: dist, band: Math.max(1, Math.ceil(dist / BAND_KM)),
        row: { h: h, c: city, la: la, ln: ln, cat: [] }
      });
    });
    return extra.length ? ordered.concat(extra).sort(cmpRank) : ordered;
  }

  // --- card rendering -------------------------------------------------------

  function harvest(grid) {
    var proto = grid && grid.querySelector('.card-wrapper');
    if (!proto) return null;
    var li = proto.closest('li');
    var card = proto.querySelector('.card');
    var inner = proto.querySelector('.card__inner');
    var media = proto.querySelector('.card__media');
    var mediaInner = proto.querySelector('.card__media .media');
    var badgeWrap = proto.querySelector('.card__badge');
    var badgeSpan = proto.querySelector('.card__badge .badge');
    var img = proto.querySelector('.card__media img');
    var headings = proto.querySelectorAll('.card__heading');
    return {
      liClass: li ? li.className : 'grid__item',
      wrapperClass: proto.className,
      cardClass: card ? card.className : 'card card--card card--media',
      cardStyle: card ? card.getAttribute('style') || '' : '',
      innerClass: inner ? inner.className : 'card__inner ratio',
      innerStyle: inner ? inner.getAttribute('style') || '' : '',
      mediaClass: media ? media.className : 'card__media',
      mediaInnerClass: mediaInner ? mediaInner.className : 'media media--transparent media--hover-effect',
      badgeWrapClass: badgeWrap ? badgeWrap.className : 'card__badge bottom left',
      badgeSpanClass: badgeSpan ? badgeSpan.className : 'badge badge--bottom-left',
      headingClass: headings.length > 1 ? headings[1].className : 'card__heading',
      sizes: img ? img.getAttribute('sizes') || '' : ''
    };
  }

  function imgUrl(prefix, path, width) {
    var u = path.indexOf('http') === 0 ? path : prefix + path;
    if (!width) return u;
    return u + (u.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function srcsetFor(prefix, tuple) {
    var path = tuple[0], w = tuple[1], out = [];
    SRCSET_WIDTHS.forEach(function (n) {
      if (w >= n) out.push(imgUrl(prefix, path, n) + ' ' + n + 'w');
    });
    out.push(imgUrl(prefix, path) + ' ' + w + 'w');
    return out.join(', ');
  }

  function money(paise) {
    var v = (paise / 100).toFixed(2), parts = v.split('.');
    return '₹' + parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
  }

  function discountPct(price, cap) {
    var frac = (cap - price) / cap;
    if (frac >= 0.2) return Math.round(frac * 10) * 10;
    return Math.round(frac * 20) * 5;
  }

  function badgeHtml(row, spec, ids) {
    var text = '';
    if (row.pm) {
      var t = norm(row.pm.type) || 'percentage';
      var cap = Number(row.pm.cap) || 0;
      if (t === 'flat' || t === 'flat_cashback') text = '₹' + cap + ' off';
      else text = row.pm.percent_off + '% off' + (cap > 0 ? ' up to ₹' + cap : '');
    } else if (row.cap && row.cap > row.p) {
      var pct = discountPct(row.p, row.cap);
      if (pct > 0) text = pct + '% OFF';
    }
    if (!text) return '';
    return '<span id="' + ids.badge + '" class="' + esc(spec.badgeSpanClass) + '">' + esc(text) + '</span>';
  }

  function ratingHtml(row) {
    if (!row.r) return '';
    var dec = row.r % 1, rd = 0;
    if (dec >= 0.3 && dec <= 0.7) rd = 0.5; else if (dec > 0.7) rd = 1;
    return '' +
      '<div class="rating" role="img" aria-label="' + esc(row.r + ' out of 5 stars') + '">' +
        '<span aria-hidden="true" class="rating-star" style="--rating: ' + Math.floor(row.r) +
        '; --rating-max: 5; --rating-decimal: ' + rd + ';"></span>' +
      '</div>' +
      '<p class="rating-text caption"><span aria-hidden="true">' + row.r + ' / 5</span></p>' +
      '<p class="rating-count caption">' +
        '<span aria-hidden="true">(' + (row.rc || 0) + ')</span>' +
        '<span class="visually-hidden">' + (row.rc || 0) + ' total reviews</span>' +
      '</p>';
  }

  function priceHtml(row) {
    var onSale = row.cap && row.cap > row.p;
    var full = row.p > 0 ? money(row.p) : 'Free Entry';
    if (row.pv && row.p > 0) full = 'From ' + full;
    var short = row.p > 0 ? full.replace(/\.00$/, '') : 'Free Entry';
    return '' +
      '<div class="price' + (onSale ? ' price--on-sale' : '') + '">' +
        '<span class="ak-distance" hidden></span>' +
        '<div class="price__container">' +
          '<div class="price__regular">' +
            '<span class="visually-hidden visually-hidden--inline">Regular price</span>' +
            '<span class="price-item price-item--regular">' + esc(full) + '</span>' +
          '</div>' +
          '<div class="price__sale">' +
            '<span class="visually-hidden visually-hidden--inline">Sale price</span>' +
            '<span class="price-item price-item--sale price-item--last">' + esc(short) + '</span>' +
          '</div>' +
          '<small class="unit-price caption hidden"></small>' +
        '</div>' +
      '</div>';
  }

  function buildCard(row, spec, opts) {
    var ids = {
      title: 'title-' + opts.sectionId + '-' + row.id,
      link: 'CardLink-' + opts.sectionId + '-' + row.id,
      badge: 'NoMediaStandardBadge-' + opts.sectionId + '-' + row.id,
      plain: 'StandardCardNoMediaLink-' + opts.sectionId + '-' + row.id
    };

    var tuple = (row.im && opts.imageCategory && row.im[opts.imageCategory]) || row.imd;
    var mediaBlock = '';
    if (tuple) {
      mediaBlock =
        '<div class="' + esc(spec.mediaClass) + '">' +
          '<div class="' + esc(spec.mediaInnerClass) + '">' +
            '<img srcset="' + esc(srcsetFor(opts.prefix, tuple)) + '"' +
              ' src="' + esc(imgUrl(opts.prefix, tuple[0], 533)) + '"' +
              ' sizes="' + esc(spec.sizes) + '"' +
              ' alt="' + esc(tuple[3] || row.t) + '"' +
              ' class="motion-reduce" loading="lazy"' +
              ' width="' + tuple[1] + '" height="' + tuple[2] + '">' +
          '</div>' +
        '</div>';
    }

    var html =
      '<div class="' + esc(spec.wrapperClass) + '"' +
        ' data-lat="' + row.la + '" data-long="' + row.ln + '"' + 
        ' data-ak-geo="1">' +
        '<div class="' + esc(spec.cardClass) + '" style="' + esc(spec.cardStyle) + '">' +
          '<div class="' + esc(spec.innerClass) + '" style="' + esc(spec.innerStyle) + '">' +
            mediaBlock +
            '<div class="card__content">' +
              '<div class="card__information">' +
                '<h2 class="card__heading">' +
                  '<a href="/products/' + esc(row.h) + '" class="full-unstyled-link"' +
                    ' id="' + ids.plain + '" aria-labelledby="' + ids.plain + ' ' + ids.badge + '">' +
                    esc(row.t) +
                  '</a>' +
                '</h2>' +
              '</div>' +
              '<div class="' + esc(spec.badgeWrapClass) + '">' + badgeHtml(row, spec, ids) + '</div>' +
            '</div>' +
          '</div>' +
          '<div class="card__content">' +
            '<div class="card__information">' +
              '<h2 class="' + esc(spec.headingClass) + '" id="' + ids.title + '">' +
                '<a href="/products/' + esc(row.h) + '" id="' + ids.link + '" class="full-unstyled-link"' +
                  ' aria-labelledby="' + ids.link + ' Badge-' + opts.sectionId + '-' + row.id + '">' +
                  esc(row.t) +
                '</a>' +
              '</h2>' +
              '<div class="card-information">' +
                '<span class="caption-large light"></span>' +
                ratingHtml(row) +
                priceHtml(row) +
              '</div>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>';

    var li = document.createElement('li');
    li.className = spec.liClass;
    li.setAttribute('data-ak-geo', '1');
    li.innerHTML = html;
    return li;
  }

  // --- page wiring ----------------------------------------------------------

  function handleOf(el) {
    var a = el.querySelector ? el.querySelector('a[href*="/products/"]') : null;
    var m = a && a.getAttribute('href').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  function renderedHandles(grid) {
    var out = [];
    if (!grid) return out;
    var items = grid.children;
    for (var i = 0; i < items.length; i++) {
      var h = handleOf(items[i]);
      if (h && out.indexOf(h) === -1) out.push(h);
    }
    return out;
  }

  function registry(cfg) {
    if (cfg._reg) return cfg._reg;
    var reg = { nodes: {}, original: [], limit: 0, cursor: 0, done: false };
    var items = cfg.grid.children;
    for (var i = 0; i < items.length; i++) {
      var li = items[i];
      reg.original.push(li);
      var h = handleOf(li);
      if (h) reg.nodes[h] = li;
    }
    reg.limit = reg.original.length;
    cfg._reg = reg;
    return reg;
  }

  function readConfigs() {
    if (window.AKGeo.grids.length) return window.AKGeo.grids;
    var nodes = document.querySelectorAll('script.ak-geo-config'), out = [];
    for (var i = 0; i < nodes.length; i++) {
      var cfg;
      try { cfg = JSON.parse(nodes[i].textContent); } catch (e) {
        console.warn('[ak-geo] unparseable config node', nodes[i]); 
        continue;
      }
      cfg.gridSelector = nodes[i].getAttribute('data-geo-grid');
      cfg.sectionId = nodes[i].getAttribute('data-geo-id');
      cfg.listLabel = nodes[i].getAttribute('data-geo-label') || nodes[i].getAttribute('data-geo-id');
      cfg.grid = document.querySelector(cfg.gridSelector);
      out.push(cfg);
    }
    window.AKGeo.grids = out;
    return out;
  }

  function withGrid(fn, override) {
    var cfgs = readConfigs();
    if (!cfgs.length) { console.log('[ak-geo] no config nodes on this page'); return; }
    cfgs.forEach(function (cfg) {
      if (!cfg.grid) { console.warn('[ak-geo] grid not found: ' + cfg.gridSelector); return; }
      var origin = originFor(cfg, override);
      if (!origin) { hidePager(cfg, false); console.warn('[ak-geo] ' + cfg.city + ' -> NO ORIGIN'); return; }
      loadFeed(cfg.feed).then(function (feed) {
        fn(cfg, feed, origin, rank(feed.items || [], cfg, origin));
      }).catch(function (e) {
        hidePager(cfg, false);
        console.warn('[ak-geo] ' + cfg.city + ' -> feed failed', e.message);
      });
    });
  }

  function report(override) {
    withGrid(function (cfg, feed, origin, ordered) {
      var shown = renderedHandles(cfg.grid);
      var pool = {};
      ordered.forEach(function (x) { pool[x.h] = true; });
      var notInPool = shown.filter(function (h) { return !pool[h]; });

      console.group('[ak-geo] ' + cfg.city + ' | ' + cfg.count + ' in pool' +
        (cfg.cats.length ? ' | cats ' + cfg.cats.join(', ') : '') + ' | grid ' + cfg.gridSelector);
      console.log('origin', origin.source, origin.lat.toFixed(4), origin.lng.toFixed(4));
      console.log('feed', feed.count, 'rows ->', ordered.length, 'in pool');
      console.log('grid renders', shown.length, '-> tail would be', Math.max(0, ordered.length - shown.length));
      if (notInPool.length) console.warn('RENDERED BUT NOT IN POOL:', notInPool.join(', '));
      console.table(ordered.slice(0, 25).map(function (x, i) {
        return {
          pos: i + 1, handle: x.h, city: x.city, tier: x.tier, sup: x.sup, same: x.same, 
          band: x.band, km: Math.round(x.dist * 10) / 10
        };
      }));
      console.groupEnd();
      cfg.lastResult = ordered;
    }, override);
  }

  // --- swap and scroll ------------------------------------------------------

  function cleanNode(li) {
    li.classList.remove('scroll-trigger', 'animate--slide-in',
      'scroll-trigger--offscreen', 'scroll-trigger--cancel');
    li.style.removeProperty('--animation-order');
    li.removeAttribute('data-cascade');
    return li;
  }

  function paintDistances(root, origin) {
    var cards = root.querySelectorAll('.card-wrapper[data-lat]');
    var n = 0;
    for (var i = 0; i < cards.length; i++) {
      var label = cards[i].querySelector('.ak-distance');
      if (!label) continue;
      var lat = parseFloat(cards[i].getAttribute('data-lat'));
      var lng = parseFloat(cards[i].getAttribute('data-long'));
      if (!isFinite(lat) || !isFinite(lng)) { label.hidden = true; continue; }
      var km = Math.ceil(airKm(origin.lat, origin.lng, lat, lng) * ROAD_FACTOR);
            if (km <= DISTANCE_CUTOFF_KM) { label.textContent = km + ' km'; label.hidden = false; n++; }
      else { label.hidden = true; }
    }
    return n;
  }

  function nodeFor(cfg, x, feed) {
    var reg = cfg._reg;
    var node = reg.nodes[x.h];
    if (!node) {
      node = buildCard(x.row, cfg._spec, {
        prefix: feed.img_prefix,
        imageCategory: cfg.imageCategory || null,
        sectionId: cfg.sectionId
      });
      reg.nodes[x.h] = node;
      reg.builtCount = (reg.builtCount || 0) + 1;
    }
    return cleanNode(node);
  }


  function appendBatch(cfg, size) {
    var reg = cfg._reg;
    if (!reg || reg.done || !cfg._ordered) return 0;
    var frag = document.createDocumentFragment();
    var added = 0;
    while (reg.cursor < cfg._ordered.length && added < size) {
      frag.appendChild(nodeFor(cfg, cfg._ordered[reg.cursor], cfg._feed));
      reg.cursor++;
      added++;
    }
    if (added) {
      cfg.grid.appendChild(frag);
      if (isRealPoint(cfg._origin)) paintDistances(cfg.grid, cfg._origin);
    }
    if (reg.cursor >= cfg._ordered.length) {
      reg.done = true;
      //console.log('[ak-geo] ' + cfg.gridSelector + ' exhausted at ' + reg.cursor + ' cards');
    }
    if (added) emitRendered(cfg, added);
    return added;
  }

    function emitRendered(cfg, added) {
    if (typeof AKEmit !== 'function' || !added) return;
    var reg = cfg._reg;
    reg.batchIndex = (reg.batchIndex || 0) + 1;
    var items = [];
    for (var i = reg.cursor - added; i < reg.cursor; i++) {
      var x = cfg._ordered[i];
      items.push({
        item_id: x.h,
        index: i + 1,
        ak_tier: (cfg._tierByHandle && cfg._tierByHandle[x.h] != null) ? cfg._tierByHandle[x.h] : 5
      });
    }
    AKEmit('event', 'ak_cards_rendered', {
      ak_list_id: cfg.listLabel || cfg.sectionId || '',
      ak_list_city: cfg.city || '',
      ak_cards_batch: added,
      ak_cards_total: reg.cursor,
      ak_pool_size: cfg._ordered.length,
      ak_batch_index: reg.batchIndex,
      ak_list_end: reg.done ? 1 : 0,
      ak_page_city: window.AK_PAGE_CITY || '(none)',
      items: items
    });
  }

  /* Position comes from the live DOM rather than the ordered array, so it is
     the rank the parent actually saw. Tier is read from an in-memory map: it
     never enters the DOM, which was the reason data-priority came off the
     cards in the first place. */
  function armClicks(cfg) {
    if (cfg._clicksArmed || !cfg.grid) return;
    cfg._clicksArmed = true;
    cfg.grid.addEventListener('click', function (e) {
      if (typeof AKEmit !== 'function') return;
      var t = e.target;
      var wrap = (t && t.closest) ? t.closest('.card-wrapper') : null;
      if (!wrap || !cfg.grid.contains(wrap)) return;
      var h = handleOf(wrap);
      if (!h) return;

      var li = (wrap.closest) ? wrap.closest('li') : null;
      var kids = cfg.grid.children, pos = 0;
      for (var i = 0; i < kids.length; i++) { if (kids[i] === li) { pos = i + 1; break; } }

      var p = {
        ak_list_id: cfg.listLabel || cfg.sectionId || '',
        ak_card_handle: h,
        ak_card_position: pos,
        ak_cards_total: (cfg._reg && cfg._reg.cursor) || 0,
        ak_page_city: window.AK_PAGE_CITY || '(none)'
      };
      if (cfg._tierByHandle && cfg._tierByHandle[h] != null) p.ak_card_tier = cfg._tierByHandle[h];

      var lat = parseFloat(wrap.getAttribute('data-lat'));
      var lng = parseFloat(wrap.getAttribute('data-long'));
      if (isRealPoint(cfg._origin) && isFinite(lat) && isFinite(lng)) {
        p.ak_distance_km = Math.round(airKm(cfg._origin.lat, cfg._origin.lng, lat, lng) * ROAD_FACTOR);
      }
      AKEmit('event', 'ak_card_click', p);
    }, true);
  }

  var scrollArmed = false, ticking = false;

  function onScrollTick() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () { ticking = false; onScrollCheck(); });
  }

  function onScrollCheck() {
    var pending = false, appended = false;
    window.AKGeo.grids.forEach(function (cfg) {
      var reg = cfg._reg;
      if (!reg || reg.done || !cfg._ordered || !cfg.grid) return;
      pending = true;
      if (reg.busy) return;
      var rect = cfg.grid.getBoundingClientRect();
      if (rect.bottom - window.innerHeight > SCROLL_MARGIN_PX) return;  // still far below
      if (rect.bottom <= 0) return;                                     // scrolled past it
      reg.busy = true;
      var n = 0;
      try { n = appendBatch(cfg, batchSize(cfg)); }
      finally { reg.busy = false; }
      if (n) { 
        appended = true; 
        //console.log('[ak-geo] appended ' + n + ' (' + reg.cursor + '/' + cfg._ordered.length + ')'); 
      }
    });
    if (appended) window.requestAnimationFrame(onScrollCheck);
    if (!pending) {
      window.removeEventListener('scroll', onScrollTick);
      window.removeEventListener('resize', onScrollTick);
      scrollArmed = false;
    }
  }

  function armScroller() {
    if (!scrollArmed) {
      scrollArmed = true;
      window.addEventListener('scroll', onScrollTick, { passive: true });
      window.addEventListener('resize', onScrollTick, { passive: true });
    }
    onScrollTick();
  }

  // --- category chips (city pages) -------------------------------------------

  function chipCats(a) {
    try { return (JSON.parse(a.getAttribute('data-cats') || '[]') || []).map(norm); }
    catch (e) { return []; }
  }

  function matchCats(row, cats) {
    var have = (row.cat || []).map(norm);
    for (var i = 0; i < cats.length; i++) if (have.indexOf(cats[i]) > -1) return true;
    return false;
  }

  function chipsBox(cfg) {
    return cfg.sectionId ? document.querySelector('[data-ak-chips][data-geo-id="' + cfg.sectionId + '"]') : null;
  }

  function paintChips(cfg) {
    var box = chipsBox(cfg);
    if (!box || !cfg._all) return;
    var chips = box.querySelectorAll('[data-ak-chip]');
    for (var i = 0; i < chips.length; i++) {
      var a = chips[i], cats = chipCats(a);
      var n = cats.length
        ? cfg._all.filter(function (x) { return matchCats(x.row, cats); }).length
        : cfg._all.length;
      var nEl = a.querySelector('[data-ak-chip-n]');
      if (nEl) nEl.textContent = String(n);
      var li = a.closest ? a.closest('li') : null;
      if (li) li.hidden = cats.length > 0 && n === 0;
      var on = cfg._chipHref ? a.getAttribute('href') === cfg._chipHref : cats.length === 0;
      a.setAttribute('aria-current', on ? 'true' : 'false');
    }
    var sum = box.querySelector('[data-ak-chip-summary]');
    if (!sum) return;
    if (!cfg._chipHref) { sum.hidden = true; return; }
    var n2 = cfg._ordered ? cfg._ordered.length : 0;
    var txt = sum.querySelector('[data-ak-chip-text]');
    if (txt) txt.textContent = n2 + (n2 === 1 ? ' place' : ' places') + ' for ' + (cfg._chipLabel || '');
    var full = sum.querySelector('[data-ak-chip-full]');
    if (full) full.setAttribute('href', cfg._chipHref);
    sum.hidden = false;
  }

  function armChips(cfg) {
    var box = chipsBox(cfg);
    if (!box) return;
    paintChips(cfg);
    if (cfg._chipsArmed) return;
    cfg._chipsArmed = true;
    box.addEventListener('click', function (e) {
      var a = (e.target && e.target.closest) ? e.target.closest('[data-ak-chip]') : null;
      if (!a || !box.contains(a) || !cfg._all || !cfg._feed) return;
      e.preventDefault();
      var cats = chipCats(a);
      cfg._chipCats = cats.length ? cats : null;
      cfg._chipHref = cats.length ? a.getAttribute('href') : null;
      cfg._chipLabel = a.getAttribute('data-label') || '';
      applyGrid(cfg, cfg._feed, cfg._origin, cfg._all);
      var top = cfg.grid.getBoundingClientRect().top - box.offsetHeight - 8;
      if (top < 0) window.scrollBy(0, top);
      if (typeof AKEmit === 'function') {
        AKEmit('event', 'ak_chip_click', {
          ak_chip: cfg._chipLabel || 'All',
          ak_chip_count: cfg._ordered ? cfg._ordered.length : 0,
          ak_page_city: window.AK_PAGE_CITY || '(none)'
        });
      }
    });
  }

  function applyGrid(cfg, feed, origin, ordered) {
    var reg = registry(cfg);
    ordered = withOrphans(cfg, reg, feed, ordered, origin);
    cfg._all = ordered;
    if (cfg._chipCats) {
      var want = cfg._chipCats;
      ordered = ordered.filter(function (x) { return matchCats(x.row, want); });
    }
    cfg._spec = harvest(cfg.grid) || cfg._spec;
    if (!cfg._spec) {
      hidePager(cfg, false);
      //console.warn('[ak-geo] nothing to harvest in ' + cfg.gridSelector); 
      return; 
    }

    cfg._feed = feed;
    cfg._origin = origin;
    cfg._ordered = ordered;
    reg.cursor = 0;
    reg.done = false;
    reg.builtCount = 0;

    cfg._tierByHandle = {};
    var pcNorm = norm(cfg.city);
    for (var t = 0; t < ordered.length; t++) {
      cfg._tierByHandle[ordered[t].h] = tierOf(ordered[t].row, pcNorm);
    }

    var limit = Math.min(reg.limit || ordered.length, ordered.length);
    var frag = document.createDocumentFragment();
    for (var i = 0; i < limit; i++) {
      frag.appendChild(nodeFor(cfg, ordered[i], feed));
      reg.cursor++;
    }

    while (cfg.grid.firstChild) cfg.grid.removeChild(cfg.grid.firstChild);
    cfg.grid.appendChild(frag);
    cfg.grid.setAttribute('data-ak-geo-applied', '1');
    if (isRealPoint(origin)) paintDistances(cfg.grid, origin);
    reg.batchIndex = 0;
    if (reg.cursor >= ordered.length) reg.done = true;
    emitRendered(cfg, limit);
    armClicks(cfg);
    armChips(cfg);

    if (!reg.done) armScroller(cfg);
    //console.log('[ak-geo] applied ' + cfg.gridSelector + ': ' + limit + ' of ' + ordered.length + ' (' + reg.builtCount + ' built), origin ' + origin.source);
  }

  function apply(override) {
    withGrid(function (cfg, feed, origin, ordered) {
      applyGrid(cfg, feed, origin, ordered);
    }, override);
  }

  function more() {
    var pending = window.AKGeo.grids.filter(function (cfg) { return !cfg._ordered; });
    if (pending.length) { 
      console.log('[ak-geo] applying first'); 
      apply(null); return; }
    window.AKGeo.grids.forEach(function (cfg) {
      if (!cfg._reg) return;
      var n = appendBatch(cfg, batchSize(cfg));
      console.log('[ak-geo] ' + cfg.gridSelector + ' +' + n + ' (' + cfg._reg.cursor + '/' + cfg._ordered.length + ')');
    });
  }

  function all() {
    window.AKGeo.grids.forEach(function (cfg) {
      if (!cfg._reg || !cfg._ordered) return;
      var n = appendBatch(cfg, cfg._ordered.length);
      console.log('[ak-geo] ' + cfg.gridSelector + ' +' + n + ', now ' + cfg._reg.cursor);
    });
  }

  function restore() {
    window.AKGeo.grids.forEach(function (cfg) {
      cfg._ordered = null;
      cfg._tierByHandle = null;
      var reg = cfg._reg;
      if (!reg || !cfg.grid) return;
      reg.cursor = 0; reg.done = false; reg.batchIndex = 0;
      while (cfg.grid.firstChild) cfg.grid.removeChild(cfg.grid.firstChild);
      reg.original.forEach(function (li) { cfg.grid.appendChild(li); });
      cfg.grid.removeAttribute('data-ak-geo-applied');
    });
    //console.log('[ak-geo] restored the Liquid order');
  }

  // --- preview harness ------------------------------------------------------

  function tidy(el) { return el.outerHTML.replace(/\s+/g, ' ').replace(/> </g, '><').trim(); }

  function preview(handle) {
    withGrid(function (cfg, feed, origin, ordered) {
      var spec = harvest(cfg.grid);
      if (!spec) return;
      var target = handle || renderedHandles(cfg.grid)[0];
      var match = null;
      for (var i = 0; i < ordered.length; i++) if (ordered[i].h === target) { match = ordered[i]; break; }
      if (!match) { console.warn('[ak-geo] ' + target + ' is not in this pool'); return; }
      var link = cfg.grid.querySelector('a[href*="/products/' + target + '"]');
      var original = link ? link.closest('li') : null;
      if (!original) { console.warn('[ak-geo] ' + target + ' is not rendered in this grid'); return; }

      var built = buildCard(match.row, spec, {
        prefix: feed.img_prefix,
        imageCategory: cfg.imageCategory || null,
        sectionId: cfg.sectionId
      });
      built.style.outline = '2px dashed magenta';
      original.parentNode.insertBefore(built, original.nextSibling);
      
      console.group('[ak-geo] preview ' + target);
      console.log('liquid :', tidy(original));
      console.log('client :', tidy(built));
      console.groupEnd();
      
    });
  }

  function clearPreview() {
    var n = document.querySelectorAll('li[data-ak-geo="1"][style*="magenta"]');
    for (var i = 0; i < n.length; i++) if (n[i].parentNode) n[i].parentNode.removeChild(n[i]);
    console.log('[ak-geo] removed ' + n.length + ' preview cards');
  }

  // --- boot -----------------------------------------------------------------

  window.AKGeo = {
    report: function () { report(null); },
    at: function (lat, lng) { report({ lat: lat, lng: lng }); },
    apply: function () { apply(null); },
    applyAt: function (lat, lng) { apply({ lat: lat, lng: lng }); },
    more: more,
    all: all,
    restore: restore,
    preview: preview,
    clearPreview: clearPreview,
    build: buildCard,
    grids: [],
    km: function (lat1, lng1, lat2, lng2) { return airKm(lat1, lng1, lat2, lng2) * ROAD_FACTOR; },
    airKm: airKm,
    paint: function (root) {
      var origin = visitorPoint();
      if (!origin) return 0;
      return paintDistances(root || document, origin);
    },
    /* Feed rows in the order a category page for this city would show them,
       for the search dropdown and the picker. Same pool test, same origin
       ladder, same comparator, so search can never disagree with the page it
       links to. opts: city, lat, lng, km (from the pointer entry), cats. */
    rankFeed: function (items, opts) {
      var o = opts || {};
      var cfg = { city: o.city, lat: o.lat, lng: o.lng, km: o.km, cats: o.cats || [] };
      var origin = originFor(cfg, null);
      if (!origin) return [];
      return rank(items || [], cfg, origin);
    },
  };

  function shouldApply() {
    return AUTO_APPLY || /[?&]akgeo=1/.test(window.location.search);
  }

  function start() {
    if (pageNum() > 1) return;
    var cfgs = readConfigs();
    if (!cfgs.length) return;
    cfgs.forEach(function (cfg) { if (cfg.grid) registry(cfg); });
    if (shouldApply()) {
      cfgs.forEach(function (cfg) { hidePager(cfg, true); });
      apply(null);
    }
    else { 
      report(null); 
      //console.log('[ak-geo] swap is gated off. Add ?akgeo=1 to the URL, or run AKGeo.apply()'); 
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('ak:location', function (e) {
    if (!e.detail || pageNum() > 1) return;
    /* Not "is there a position": clearing a pin with no device fix moves the
       origin to the centroid and reports no position at all. Not "always"
       either: re-picking the same city rebuilds the grid into an identical
       order. Compare the origin instead. */
    var moved = window.AKGeo.grids.some(function (cfg) {
      if (!cfg._origin) return true;
      var o = originFor(cfg, null);
      return !o || o.source !== cfg._origin.source ||
             o.lat !== cfg._origin.lat || o.lng !== cfg._origin.lng;
    });
    if (!moved) { console.log('[ak-geo] location changed, origin unmoved, skipping'); return; }
    if (shouldApply()) { console.log('[ak-geo] origin moved, re-applying'); apply(null); }
    else { console.log('[ak-geo] origin moved, re-running'); report(null); }
  });
})();